import { designSystemColors } from '@klv/shared/styles/colors';

import type { IChartXTick } from './types';

const ChartXTick = ({ x, y, payload, offsetFirst, backgroundColor, fontSizeClamp, fontWeight }: IChartXTick) => {
  let anchor: 'start' | 'middle' = 'middle';
  if (payload.index === 0 && offsetFirst) {
    anchor = 'start';
  }

  const fill = backgroundColor === 'charcoal' ? designSystemColors.white : designSystemColors.charcoal;

  return (
    <g fontFamily='Sohne' fontSize={fontSizeClamp} fontWeight={fontWeight}>
      <text x={x} y={y} dy={23} textAnchor={anchor} fill={fill}>
        {payload.value}
      </text>
    </g>
  );
};

export default ChartXTick;
